


const minSideGlassWidth = 100;
const minSideGlassFromEdge = 50;
const minUpGlassHeight = 100;
const maxUpGlassHeight = 400;
const defaultSpaceUnderDoor = 150;
const defaultUpGlassHeight = 300;
const defaultDoorHeight = 1850;

let buildGlassWall = (measurements) =>
{
	let result = {}
	let limits = getGlassMeasurementLimits(measurements);
	if (limits.leftSideGlassMaxWidth > 0) {
		result.leftSideGlassEnabled = true;
		result.leftSideGlassHeight = measurements.height / 2;
		result.leftSideGlassWidth = limits.leftSideGlassMaxWidth;
	}
	else {
		result.leftSideGlassEnabled = false;
		result.leftSideGlassHeight = measurements.height / 2;
		result.leftSideGlassWidth = 200;
	}
	if (limits.rightSideGlassMaxWidth > 0) {
		result.rightSideGlassEnabled = true;
		result.rightSideGlassHeight = measurements.height / 2;
		result.rightSideGlassWidth = limits.rightSideGlassMaxWidth;
	}
	else {
		result.rightSideGlassEnabled = false;
		result.rightSideGlassHeight = measurements.height / 2;
		result.rightSideGlassWidth = 200;
	}
	let spaceForUpGlass = measurements.height - defaultSpaceUnderDoor - defaultDoorHeight;
	let upGlassGeight = 0;
	if (spaceForUpGlass >= minUpGlassHeight) 
	{
		upGlassGeight = Math.min(spaceForUpGlass, maxUpGlassHeight);
		result.upGlassEnabled = true;
	}
	else
	{
		result.upGlassEnabled = false;		
	}
	result.upGlassHeight = upGlassGeight
	result.spaceUnderDoor = defaultSpaceUnderDoor;
	result.doorHeight = measurements.height - upGlassGeight - defaultSpaceUnderDoor;

	result.allowAddOrRemoveGlass = true;
	result = Object.assign(result, limits);
	return result;
};
let getGlassMeasurementLimits = (measurements) => {
	let result = {}

	let spaceForLeftSideGlass = measurements.doorFromLeft - minSideGlassFromEdge;
	result.leftSideGlassMaxWidth = spaceForLeftSideGlass >= minSideGlassWidth ? spaceForLeftSideGlass : 0;	
	result.leftSideGlassMinWidth = minSideGlassWidth;
	result.leftSideGlassMaxHeight = measurements.height;
	result.leftSideGlassMinHeight = defaultUpGlassHeight;

	let spaceAtRightSideGlass = measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth - minSideGlassFromEdge;
	result.rightSideGlassMaxWidth = spaceAtRightSideGlass >= minSideGlassWidth ? spaceAtRightSideGlass : 0;
	result.rightSideGlassMinWidth = minSideGlassWidth;
	result.rightSideGlassMaxHeight = measurements.height;

	result.rightSideGlassMinHeight = defaultUpGlassHeight;
	result.minUpGlassHeight = minUpGlassHeight;
	result.maxUpGlassHeight = maxUpGlassHeight;
	return result;
}


export { buildGlassWall,getGlassMeasurementLimits };
